/* Benachrichtigung „Wieder verfügbar“: sendet die E-Mail-Adresse an den Newsletter-Dienst (oeffentliche Client-API) und merkt sich Anmeldungen im Browser. */

const KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/back-in-stock-subscriptions';
const KLAVIYO_REVISION = '2026-07-15';
const STORAGE_KEY = 'kgroup:notify';

const storage = {
  read() {
    try {
      const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.map(String) : [];
    } catch {
      return [];
    }
  },
  add(variantId) {
    try {
      const list = storage.read();
      if (!list.includes(String(variantId))) list.push(String(variantId));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {
      /* Speicher nicht verfügbar, dann nur für diese Seite gemerkt */
    }
  },
  has(variantId) {
    return storage.read().includes(String(variantId));
  },
};

class KgNotify extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.message = this.querySelector('[data-notify-message]');
    this.button = this.querySelector('[data-notify-button]');
    this.buttonText = this.querySelector('[data-notify-button-text]');
    this.banner = this.querySelector('[data-notify-banner]');
    this.form?.addEventListener('submit', (event) => this.submit(event));
    if (storage.has(this.dataset.variant)) this.markSubscribed();
  }

  markSubscribed() {
    this.classList.add('is-subscribed');
    this.button?.classList.add('is-subscribed');
    if (this.buttonText && this.dataset.subscribedText) this.buttonText.textContent = this.dataset.subscribedText;
    if (this.banner) this.banner.hidden = false;
  }

  async submit(event) {
    event.preventDefault();
    const input = this.form.elements.email;
    const email = input.value.trim();
    if (!email || !input.checkValidity()) {
      this.show(this.dataset.invalidText, true);
      input.focus();
      return;
    }
    /*
      Nicht im Formular suchen: Der Knopf steht in der Fusszeile des Schubers und gehoert
      ueber `form` dazu, liegt aber nicht darin.
    */
    const submit = this.querySelector('[data-notify-submit]');
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${KLAVIYO_ENDPOINT}?company_id=${encodeURIComponent(this.dataset.key)}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: KLAVIYO_REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: this.profile(email) } },
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.dataset.variant}` } },
            },
          },
        }),
      });
      if (!response.ok) throw new Error(`Klaviyo ${response.status}`);
      storage.add(this.dataset.variant);
      this.show(this.dataset.successText, false);
      this.markSubscribed();
      this.dispatchEvent(new CustomEvent('notify:subscribed', { bubbles: true, detail: { variant: this.dataset.variant, email } }));
    } catch {
      this.show(this.dataset.errorText, true);
    } finally {
      submit.disabled = false;
      submit.removeAttribute('aria-busy');
    }
  }

  profile(email) {
    const attributes = { email };
    if (this.dataset.firstName) attributes.first_name = this.dataset.firstName;
    if (this.dataset.lastName) attributes.last_name = this.dataset.lastName;
    return attributes;
  }

  show(text, isError) {
    if (!this.message) return;
    this.message.textContent = text || '';
    this.message.classList.toggle('is-error', Boolean(isError));
    this.message.hidden = !text;
  }
}

customElements.define('kg-notify', KgNotify);
